// document.addEventListener("DOMContentLoaded", function () {
//     if(window.wizzyConfig.common.isOnProductViewPage)
//     {
//         wizzyLazyAssets.load();
//     }
// });
window.onWizzyScriptLoaded = function () {
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
        // console.log("before_init");
        window.wizzyConfig.filters.configs.layout = "v1";
        data.search.configs.facets.leftFacets.mobileCollapsible = true;
        data.filters.configs.keepOpenedInMobileAfterApply = true;
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
            {
                dom: "#search_input",
                type: "search"
            }
        ]
        
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            "main"
        ]

        return data;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
        // data?.filters?.showOOSProductsInOrder = true;
        // if(data.filters)
        // {
        //     // data.filters.showOOSProductsInOrder = true;
        // }

        return data;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
        // console.log("before_init");
        window.wizzyConfig.filters.configs.layout = "v1";
        data.search.configs.facets.leftFacets.mobileCollapsible = true;
        data.filters.configs.keepOpenedInMobileAfterApply = true;
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
            {
                dom: "#search_input",
                type: "search"
            }
        ]
        
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            "main"
        ]

        return data;
    });

    const colorMap = new Map([["Rust", ["#b7410e", !1]], ["Multi", ["https://i.ibb.co/BVjj74X/classic-color-spectrum-rgb-line-gradient-vector-522680-173-copy.png", !0]], ["Peach", ["#ffdab9", !1]], ["Golden", ["#ffd900", !1]], ["Off-White", ["#f5f5f5", !1]], ["Cream", ["#fffdd0", !1]], ["Sky Blue", ["#87CEEB", !1]], ["Navy Blue", ["#000080", !1]], ["Light Blue", ["#ADD8E6", !1]], ["Olive Green", ["#556B2F", !1]], ["Light Green", ["#90EE90", !1]], ["Dark Grey", ["#A9A9A9", !1]], ["Dark Blue", ["#00008B", !1]], ["Jet Black", ["#000000", !1]], ["Bright White", ["#FFFFFF", !1]], ["Light Grey", ["#D3D3D3", !1]], ["Wine", ["#722F37", !1]], ["Teal Blue", ["#008080", !1]], ["Royal Blue", ["#4169E1", !1]], ["Indigo Blue", ["#4B0082", !1]], ["Mid Blue", ["#0000CD", !1]], ["Peacock Blue", ["#006994", !1]], ["Deep Blue", ["#000080", !1]], ["Aqua Blue", ["#00FFFF", !1]], ["Ice Blue", ["#BCE6E6", !1]], ["Night Blue", ["#191970", !1]], ["Denim Blue", ["#1560BD", !1]], ["Turquoise Blue", ["#40E0D0", !1]], ["Brick Red", ["#B22222", !1]], ["Light Red", ["#FF6961", !1]], ["Dark Red", ["#8B0000", !1]], ["Bright Red", ["#FF0000", !1]], ["Carrot red", ["#FF4500", !1]], ["Burn Red", ["#9A3334", !1]], ["Cardinal Red", ["#C41E3A", !1]], ["Oxblood Red", ["#800020", !1]], ["Rio Red", ["#DA2C43", !1]], ["Rose Red", ["#FF033E", !1]], ["Rumba Red", ["#C76E70", !1]], ["Spice Red", ["#A23C3C", !1]], ["Tango Red", ["#E25822", !1]], ["Deep Red", ["#8B0000", !1]], ["Mustard Yellow", ["#FFDB58", !1]], ["Light Yellow", ["#FFFFE0", !1]], ["Lemon Yellow", ["#FFF44F", !1]], ["Mellow Yellow", ["#F8DE7E", !1]], ["Bright Yellow", ["#FFFF00", !1]], ["Golden Yellow", ["#FFD700", !1]], ["Chrome Yellow", ["#FFA700", !1]], ["Corn Yellow", ["#FBEC5D", !1]], ["Musturd Yellow", ["#FFDB58", !1]], ["Pale Yellow", ["#EEE8AA", !1]], ["Pastel Yellow", ["#FDFD96", !1]], ["Taffy Yellow", ["#F8DE7E", !1]], ["Dark Green", ["#006400", !1]], ["Light Pink", ["#FFB6C1", !1]], ["Onion Pink", ["#F5B9F5", !1]], ["Island Pink", ["#FFD1DC", !1]], ["Lilac Pink", ["#FFC0CB", !1]], ["Rose Pink", ["#FF66CC", !1]], ["Coral Pink", ["#FF7F50", !1]], ["Dusty Pink", ["#D8BFD8", !1]], ["Send Pink", ["#FF91A4", !1]], ["Blossom Pink", ["#FFC3A0", !1]], ["Delicacy Pink", ["#FEC3AC", !1]], ["Flamingo Pink", ["#FC8EAC", !1]], ["Pastel Pink", ["#FFD1BB", !1]], ["Baby Pink", ["#FFC0CB", !1]], ["Pastel Purple", ["#B39EB5", !1]], ["Dark Purple", ["#800080", !1]], ["Beige", ["#F5F5DC", !1]], ["Light Purple", ["#E6E6FA", !1]], ["Cloud Cream", ["#FFF8E7", !1]], ["Custard Cream", ["#FFF0C1", !1]], ["Dark Cream", ["#EEE8AA", !1]], ["Dawn Cream", ["#FFFAF0", !1]], ["Fawn Cream", ["#E5AA70", !1]], ["Italian Cream", ["#F6ECD8", !1]], ["Light Orange", ["#FFD68F", !1]], ["Apricot Orange", ["#FDD5B1", !1]], ["Bright Orange", ["#FF8C00", !1]], ["Burnt Orange", ["#FF4500", !1]], ["Coral Orange", ["#FF7F50", !1]], ["Golden Orange", ["#FFD700", !1]], ["Apricot Orange", ["#FBCEB1", !1]], ["Dark Olive", ["#556B2F", !1]], ["Olive Brown", ["#806517", !1]], ["Light Olive", ["#AAB300", !1]], ["Olive Grey", ["#B5B35C", !1]], ["Branch Olive", ["#5F6527", !1]], ["Dark Olive Green", ["#556B2F", !1]], ["Deep Olive Green", ["#556B2F", !1]], ["Dusty Olive", ["#8A8662", !1]], ["Olive Melange", ["#6B6C4A", !1]], ["Dark Maroon", ["#800000", !1]], ["Maroon gold", ["#B03060", !1]], ["Silver Grey", ["#C0C0C0", !1]], ["Lime Green", ["#00FF00", !1]], ["State Gray", ["#808080", !1]], ["Teal Green", ["#008080", !1]], ["Dusty Teal", ["#4e5d4e", !1]], ["Teal Black", ["#003838", !1]], ["Teal Grey", ["#69838d", !1]], ["Midnight Navy", ["#000080", !1]], ["Grey Melange", ["#808080", !1]], ["Charcoal Grey", ["#36454F", !1]], ["Ercus Melange", ["#B5B5B5", !1]], ["Air Force Blue", ["#5D8AA8", !1]], ["Aquamarine Blue", ["#7FFFD4", !1]], ["Carrot Brown", ["#ED9121", !1]], ["Colonial Blue", ["#002F6C", !1]], ["Cornet Blue", ["#6495ED", !1]], ["Deep Wine", ["#8B0000", !1]], ["Bottle Green", ["#092E20", !1]]])
    function findHaxCode(key) {
        return colorMap.has(key) ? colorMap.get(key) : [key, !1];
    }
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      // console.log("before render results 1");
      if (payload.api === "search" || payload.api === "filter") {
        var facets = payload.response.payload.facets;
        // console.log(facets);
        if(facets)
        {
          // console.log("inside facets condition");
          facets.forEach((facet) => {
            if(facet.key === "colors")
            {
              // console.log("inside colors");
              facet.data.forEach((item) => {
                // console.log("inside loop");
                // console.log(item.key);
                let color = findHaxCode(item.key) || ["#e5e5e5", !1];
                // console.log(color);
                // console.log("inside loop 1");
                (item.isSwatch = !0),
                  (item.isURLSwatch = color[1]),
                  (item.isVisualSwatch = !0),
                  (item.swatchValue = color[0]),
                  (item.data = {
                    value: item.key,
                    swatch: {
                      type: "visual",
                      value: color[0],
                    },
                  });
              });
            }
          });
        }
        // console.log(payload);
      }
    //   console.log("before render results 2");
      console.log("Before render");
      return payload;
    }
  );
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
        console.log("BEFORE_SEARCH");
        // const sellingPriceExists = data.sort.some(
        // (s) => s.field === "product_wizzy-best-selling_sortOrder:float" && s.order === "asc"
        // );

        // if (!sellingPriceExists && data.sort[0].field === "relevance") {
        // data.sort.push({field: "product_wizzy-best-selling_sortOrder:float", order: "asc"});
            
        // // data.sort = [{ field: "sellingPrice", order: "asc", isForParent: !1}];
        // }
        let cancel_btn = document.querySelector('.search--cancel');
        if(cancel_btn)
        {
            cancel_btn.click();
        }

        return data;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
        products.forEach((product) => {
            product.sellingPrice = product.sellingPrice?.replace(/\.00$/, '');
            product.price = product.price?.replace(/\.00$/, '');
            let attributes = product.attributes;
            if(attributes)
            {
                attributes.forEach((attr) => {
                    if(attr.id === "product_variant_prices")
                    {
                        let values = attr.values;
                        const seen = {};
                        let allDifferent = true;
                        let minPrice;
                        if(values.length > 1)
                        {
                            minPrice = values[0].value[0];
                        }
                        else
                        {
                            allDifferent = false;
                        }
                        values.forEach((val) => {
                            let price = val.value[0];
                            if (price < minPrice) {
                                minPrice = price;
                            }
                            if (seen[price]) {
                                allDifferent = false;
                            } else {
                                seen[price] = true;
                            }
                        });
                        if(allDifferent)
                        {
                            product.diffrentPrices = true;
                            product.minPrice = minPrice;
                        }
                    }
                })
            }
        })

        return products;
    });
    function changeGrid(columns)
    {
        const el = document.querySelector('.wizzy-search-results');
        if(window.innerWidth >= 768)
        {
            
            if (el) {
                el.setAttribute('data-columns', columns);
            }
        }
        else
        {
            if (el) {
                el.setAttribute('data-mobile-columns', columns);
            }
        }
    }
    function updateFacetSelectedValues() {
        // STEP 1 — Read selected filters
        const selectedItems = document.querySelectorAll(".wizzy-selected-facet-list li");
        const selectedMap = {};

        selectedItems.forEach(li => {
            const key = li.getAttribute("data-facetkey");
            const value = li.getAttribute("title")?.trim(); // value stored in title

            if (!key || !value) return;

            if (!selectedMap[key]) {
                selectedMap[key] = [];
            }
            selectedMap[key].push(value);
        });

        // STEP 2 — Update each facet block
        document.querySelectorAll(".wizzy-search-filters-left-wrapper .wizzy-filters-facet-block").forEach(block => {
            const facetKey = block.getAttribute("data-key");
            if (!facetKey) return;

            // Create UI placeholder if missing
            let displayDiv = block.querySelector(".facet-selected-values");
            if (!displayDiv) {
                displayDiv = document.createElement("div");
                displayDiv.className = "facet-selected-values";

                const head = block.querySelector(".wizzy-facet-head");
                const body = block.querySelector(".wizzy-facet-body");

                if (head && body) head.insertAdjacentElement("afterend", displayDiv);
            }

            let values = selectedMap[facetKey];

            // SPECIAL CASE — sellingPrice
            if (facetKey === "sellingPrice" && (!values || values.length === 0)) {
                
                // Find slider inside this block
                const slider = block.querySelector(".wizzy-facet-range-slider");

                if (slider) {
                    const min = slider.getAttribute("data-min");
                    const max = slider.getAttribute("data-max");

                    if (min && max) {
                        displayDiv.innerText = `₹${min} - ₹${max}`;
                    } else {
                        displayDiv.innerText = "All";
                    }
                } else {
                    displayDiv.innerText = "All";
                }

                return; // done for price facet
            }

            // NORMAL FACETS
            if (values && values.length > 0) {
                displayDiv.innerText = values.join(", ");
            } else {
                displayDiv.innerText = "All";
            }
        });
    }

    function initWizzyQuickProductTypeFilters() {
        const summaryWrapper = document.querySelector('.wizzy-search-summary-wrapper');
        if (!summaryWrapper) return;

        const oldWrapper = document.querySelector('.wizzy-quick-filters-wrapper');
        oldWrapper && oldWrapper.remove();

        const facetBlock = document.querySelector(
            ".wizzy-search-filters-left-wrapper .wizzy-filters-facet-block[data-key='product_product_type']"
        );
        if (!facetBlock) return;

        const facetItems = facetBlock.querySelectorAll(
            '.wizzy-facet-list .facet-item-label-value'
        );
        if (!facetItems || facetItems.length <= 1) return;

        const selectedItems = document.querySelectorAll('.wizzy-selected-facet-list li');
        const selectedMap = {};

        selectedItems.forEach(li => {
            const key = li.getAttribute('data-facetkey');
            const value = li.getAttribute('title')?.trim();
            if (!key || !value) return;

            if (!selectedMap[key]) selectedMap[key] = [];
            selectedMap[key].push(value);
        });

        const selectedProductTypes = selectedMap['product_product_type'] || [];

        const quickWrapper = document.createElement('div');
        quickWrapper.className = 'wizzy-quick-filters-wrapper';

        facetItems.forEach((facetItem) => {
            const label = facetItem.textContent.trim();
            if (!label) return;

            const quickItem = document.createElement('div');
            quickItem.className = 'wizzy-quick-filter-item';
            quickItem.textContent = label;

            if (selectedProductTypes.includes(label)) {
            quickItem.classList.add('selected');
            }

            quickItem.addEventListener('click', () => {
            quickWrapper
                .querySelectorAll('.wizzy-quick-filter-item')
                .forEach(el => el.classList.remove('selected'));

            quickItem.classList.add('selected');
            facetItem.click();
            });

            quickWrapper.appendChild(quickItem);
        });

        summaryWrapper.insertAdjacentElement('afterend', quickWrapper);
    }






    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
        updateFacetSelectedValues();
        initWizzyQuickProductTypeFilters();
        let apply_btn = document.querySelector('.wizzy-apply-all-button-block');
        if(apply_btn)
        {
            apply_btn.addEventListener('click', function(){
                let close_btn = document.querySelector('.wizzy-filters-close-btn');
                if(close_btn)
                {
                    close_btn.click();
                }
            })
        }
        // console.log("view_render");
        let grids;
        if(window.innerWidth >= 768)
        {
            let two_grid = document.querySelector('.wz-two-grid');
            let four_grid = document.querySelector('.wz-four-grid');
            let six_grid = document.querySelector('.wz-six-grid');
            grids = localStorage.getItem('wz-grids') || 4;
            if(grids == 6)
            {
                six_grid.classList.add('selected');
                two_grid.classList.remove('selected');
                four_grid.classList.remove('selected');
            }
            else if(grids == 4){
                four_grid.classList.add('selected');
                six_grid.classList.remove('selected');
                two_grid.classList.remove('selected');
            }
            else
            {
                two_grid.classList.add('selected');
                four_grid.classList.remove('selected');
                six_grid.classList.remove('selected');
            }
            changeGrid(grids);
            if(two_grid && four_grid && six_grid)
            {
                // console.log("inside grids");
                two_grid.addEventListener('click', function(){
                    two_grid.classList.add('selected');
                    four_grid.classList.remove('selected');
                    six_grid.classList.remove('selected');
                    localStorage.setItem('wz-grids', 2);
                    changeGrid(2);
                });
                four_grid.addEventListener('click', function(){
                    four_grid.classList.add('selected');
                    six_grid.classList.remove('selected');
                    two_grid.classList.remove('selected');
                    localStorage.setItem('wz-grids', 4);
                    changeGrid(4);
                });
                six_grid.addEventListener('click', function(){
                    six_grid.classList.add('selected');
                    two_grid.classList.remove('selected');
                    four_grid.classList.remove('selected');
                    localStorage.setItem('wz-grids', 6);
                    changeGrid(6);
                });
            }
        }
        else
        {
            let one_grid = document.querySelector('.wz-one-grid');
            let two_grid = document.querySelector('.for-mobile .wz-two-grid');
            let three_grid = document.querySelector('.wz-three-grid');
            grids = localStorage.getItem('wz-mobile-grid') || 2;
            if(grids == 1)
            {
                one_grid.classList.add('selected');
                two_grid.classList.remove('selected');
                three_grid.classList.remove('selected');
            }
            else if(grids == 2)
            {
                two_grid.classList.add('selected');
                three_grid.classList.remove('selected');
                one_grid.classList.remove('selected');
            }
            else if(grids == 3)
            {
                three_grid.classList.add('selected');
                two_grid.classList.remove('selected');
                one_grid.classList.remove('selected');
            }
            changeGrid(grids);
            if(one_grid && two_grid && three_grid)
            {
                one_grid.addEventListener('click', function(){
                    one_grid.classList.add('selected');
                    two_grid.classList.remove('selected');
                    three_grid.classList.remove('selected');
                    localStorage.setItem('wz-mobile-grid', 1);
                    changeGrid(1);
                });
                two_grid.addEventListener('click', function(){
                    two_grid.classList.add('selected');
                    three_grid.classList.remove('selected');
                    one_grid.classList.remove('selected');
                    localStorage.setItem('wz-mobile-grid', 2);
                    changeGrid(2);
                });
                three_grid.addEventListener('click', function(){
                    three_grid.classList.add('selected');
                    two_grid.classList.remove('selected');
                    one_grid.classList.remove('selected');
                    localStorage.setItem('wz-mobile-grid', 3);
                    changeGrid(3);
                });
            }
        }
        // if(window.innerWidth >= 768)
        // {
        //     let two_grid = document.querySelector('.wz-two-grid');
        //     let four_grid = document.querySelector('.wz-four-grid');
        //     let six_grid = document.querySelector('.wz-six-grid');
            
        // }
        // else
        // {
        //     let one_grid = document.querySelector('.wz-one-grid');
        //     let two_grid = document.querySelector('.wz-two-grid');
        //     let three_grid = document.querySelector('.wz-six-grid');
            
        // }


        console.log("view render");
        return data;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
        updateFacetSelectedValues();
        initWizzyQuickProductTypeFilters();
        let apply_btn = document.querySelector('.wizzy-apply-all-button-block');
        if(apply_btn)
        {
            apply_btn.addEventListener('click', function(){
                let close_btn = document.querySelector('.wizzy-filters-close-btn');
                if(close_btn)
                {
                    close_btn.click();
                }
            })
        }
        // console.log("view_render");
        let grids;
        if(window.innerWidth >= 768)
        {
            let two_grid = document.querySelector('.wz-two-grid');
            let four_grid = document.querySelector('.wz-four-grid');
            let six_grid = document.querySelector('.wz-six-grid');
            grids = localStorage.getItem('wz-grids') || 4;
            if(grids == 6)
            {
                six_grid.classList.add('selected');
                two_grid.classList.remove('selected');
                four_grid.classList.remove('selected');
            }
            else if(grids == 4){
                four_grid.classList.add('selected');
                six_grid.classList.remove('selected');
                two_grid.classList.remove('selected');
            }
            else
            {
                two_grid.classList.add('selected');
                four_grid.classList.remove('selected');
                six_grid.classList.remove('selected');
            }
            changeGrid(grids);
            if(two_grid && four_grid && six_grid)
            {
                // console.log("inside grids");
                two_grid.addEventListener('click', function(){
                    two_grid.classList.add('selected');
                    four_grid.classList.remove('selected');
                    six_grid.classList.remove('selected');
                    localStorage.setItem('wz-grids', 2);
                    changeGrid(2);
                });
                four_grid.addEventListener('click', function(){
                    four_grid.classList.add('selected');
                    six_grid.classList.remove('selected');
                    two_grid.classList.remove('selected');
                    localStorage.setItem('wz-grids', 4);
                    changeGrid(4);
                });
                six_grid.addEventListener('click', function(){
                    six_grid.classList.add('selected');
                    two_grid.classList.remove('selected');
                    four_grid.classList.remove('selected');
                    localStorage.setItem('wz-grids', 6);
                    changeGrid(6);
                });
            }
        }
        else
        {
            let one_grid = document.querySelector('.wz-one-grid');
            let two_grid = document.querySelector('.for-mobile .wz-two-grid');
            let three_grid = document.querySelector('.wz-three-grid');
            grids = localStorage.getItem('wz-mobile-grid') || 2;
            if(grids == 1)
            {
                one_grid.classList.add('selected');
                two_grid.classList.remove('selected');
                three_grid.classList.remove('selected');
            }
            else if(grids == 2)
            {
                two_grid.classList.add('selected');
                three_grid.classList.remove('selected');
                one_grid.classList.remove('selected');
            }
            else if(grids == 3)
            {
                three_grid.classList.add('selected');
                two_grid.classList.remove('selected');
                one_grid.classList.remove('selected');
            }
            changeGrid(grids);
            if(one_grid && two_grid && three_grid)
            {
                one_grid.addEventListener('click', function(){
                    one_grid.classList.add('selected');
                    two_grid.classList.remove('selected');
                    three_grid.classList.remove('selected');
                    localStorage.setItem('wz-mobile-grid', 1);
                    changeGrid(1);
                });
                two_grid.addEventListener('click', function(){
                    two_grid.classList.add('selected');
                    three_grid.classList.remove('selected');
                    one_grid.classList.remove('selected');
                    localStorage.setItem('wz-mobile-grid', 2);
                    changeGrid(2);
                });
                three_grid.addEventListener('click', function(){
                    three_grid.classList.add('selected');
                    two_grid.classList.remove('selected');
                    one_grid.classList.remove('selected');
                    localStorage.setItem('wz-mobile-grid', 3);
                    changeGrid(3);
                });
            }
        }
        // if(window.innerWidth >= 768)
        // {
        //     let two_grid = document.querySelector('.wz-two-grid');
        //     let four_grid = document.querySelector('.wz-four-grid');
        //     let six_grid = document.querySelector('.wz-six-grid');
            
        // }
        // else
        // {
        //     let one_grid = document.querySelector('.wz-one-grid');
        //     let two_grid = document.querySelector('.wz-two-grid');
        //     let three_grid = document.querySelector('.wz-six-grid');
            
        // }


        console.log("products cache");
        return data;
    });
}